import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import BannerComponent from '../components/BannerComponent';
import {CustomMessages} from '../components/CustomMessages';
import BlockUi from '../components/waitPanel/BlockUi';
import CardOrderService from '../services/CardOrderService';
import CardService from '../services/CardService';
import SettingService from '../services/SettingService';
import CardOrderListContainer from './CardOrderListContainer';
import CardOrderTemplateList from './CardOrderTemplateList';

class CardOrdersDraftListContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new CardOrderService();
        this.cardService = new CardService();
        this.settingService = new SettingService();
        this.state = {
            activeIndex: 0,
            placedCount: 0,
            inProgressCount: 0,
            draftsCount: 0,
            order: undefined,
            renderBanner: true,
            appStoreUrl: '',
            googlePlayUrl: '',
            draftList: {
                content: [],
                totalElements: 0,
            },
            orderedList: {
                content: [],
                totalElements: 0,
            },
            templateList: {
                content: [],
                totalElements: 0,
            },
        };
        this.handleTabChange = this.handleTabChange.bind(this);
        this.hideBanner = this.hideBanner.bind(this);
        this.refreshList = this.refreshList.bind(this);
    }

    componentDidMount() {
        const {t} = this.props;
        super.componentDidMount();
        this.blockUi();
        let activeIndex = this.readCookie(`order-card-list-activeIndex`);
        const orderId = this.extractOrderIdFromSearch(this.props.history, 'id');
        const draftOrderId = this.extractOrderIdFromSearch(this.props.history, 'draftId');
        if (!!draftOrderId) {
            activeIndex = 1;
        } else if (!!orderId || activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.setState({activeIndex: parseInt(activeIndex)});
        this.settingService
            .getAppLinkUrl()
            .then((resp) => this.setState({appStoreUrl: resp['APP_STORE_URL'], googlePlayUrl: resp['GOOGLE_PLAY_URL']}))
            .catch((err) => this.showErrorMessage(t('error.getAppUrlError')));
        this.refreshList();
    }

    extractOrderIdFromSearch(history, paramName) {
        if (!!history && !!history.location && !!history.location.search) {
            const search = new URLSearchParams(history.location.search);
            return search.get(paramName);
        }
        return undefined;
    }

    refreshList() {
        this.service
            .getList()
            .then((res) => {
                res.draftList.content.map((item) => {
                    item.orderDate = new Date(item.orderDate);
                    return item;
                });
                res.orderedList.content.map((item) => {
                    item.orderDate = new Date(item.orderDate);
                    return item;
                });
                this.setState(
                    {
                        draftList: res.draftList,
                        orderedList: res.orderedList,
                        templateList: res.templateList,
                    },
                    () => {
                        this.unblockUi();
                    }
                );
            })
            .catch((err) => {
                this.unblockUi();
            });
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`order-card-list-activeIndex`, this.state.activeIndex);
            }
        );
    }

    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }

    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    hideBanner() {
        this.setState({renderBanner: false});
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div className='min-height-130 header-banner'>
                        <BannerComponent
                            key={'header-banner'}
                            label={t('order-card.registrationBanner')}
                            iconSvg='ico_blue_banner_icon'
                            iconSide='left'
                            subLabel={t('order-card.downloadAppBannerSublabel')}
                            closeable
                            handleHide={this.hideBanner}
                            rendered={this.state.renderBanner}
                            rightIconItems={[
                                {iconSvg: 'ico_download_appstore', handleClick: () => (window.location.href = this.state.appStoreUrl)},
                                {iconSvg: 'ico_download_google_play', handleClick: () => (window.location.href = this.state.googlePlayUrl)},
                            ]}
                        />
                    </div>
                    <div className='container-fluid'>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}>
                            <TabPanel header={`${t('order-card.placedHeader')} (${this.state.orderedList.totalElements})`}>
                                <CardOrderListContainer
                                    disableSelection
                                    lazy={false}
                                    list={this.state.orderedList.content}
                                    size={this.state.orderedList.totalElements}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    refreshList={this.refreshList}
                                    embedded
                                    _isMounted={this._isMounted}
                                    orderId={this.props.elementId}
                                    history={this.props.history}
                                />
                            </TabPanel>
                            <TabPanel header={`${t('order-card.inProgressHeader')} (${this.state.draftList.totalElements})`}>
                                <CardOrderListContainer
                                    disableSelection
                                    draft
                                    lazy={false}
                                    list={this.state.draftList.content}
                                    size={this.state.draftList.totalElements}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    refreshList={this.refreshList}
                                    embedded
                                    _isMounted={this._isMounted}
                                    history={this.props.history}
                                />
                            </TabPanel>
                            <TabPanel header={`${t('order-card.draftsHeader')} (${this.state.templateList.totalElements})`}>
                                <CardOrderTemplateList
                                    lazy={false}
                                    list={this.state.templateList.content}
                                    size={this.state.templateList.totalElements}
                                    blockUi={this.blockUi}
                                    unblockUi={this.unblockUi}
                                    showMessage={this.showMessage}
                                    refreshList={this.refreshList}
                                    embedded
                                    _isMounted={this._isMounted}
                                />
                            </TabPanel>
                        </TabView>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

CardOrdersDraftListContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    newUrl: '/#/order-new',
};

CardOrdersDraftListContainer.propTypes = {
    newUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(CardOrdersDraftListContainer);
